import GilroyRegularWOFF from './fonts/Gilroy/Gilroy-Regular.woff';
import GilroyRegularWOFF2 from './fonts/Gilroy/Gilroy-Regular.woff2';

import GilroyExtraboldWOFF from './fonts/Gilroy/Gilroy-Extrabold.woff'
import GilroyExtraboldWOFF2 from './fonts/Gilroy/Gilroy-Extrabold.woff2'

import GilroyThinWOFF from './fonts/Gilroy/Gilroy-Thin.woff'
import GilroyThinWOFF2 from './fonts/Gilroy/Gilroy-Thin.woff2'

import GilroyBoldWOFF from './fonts/Gilroy/Gilroy-Bold.woff'
import GilroyBoldWOFF2 from './fonts/Gilroy/Gilroy-Bold.woff2'

import GilroyBlackWOFF from './fonts/Gilroy/Gilroy-Black.woff'
import GilroyBlackWOFF2 from './fonts/Gilroy/Gilroy-Black.woff2'

import GilroyLightWOFF from './fonts/Gilroy/Gilroy-Light.woff'
import GilroyLightWOFF2 from './fonts/Gilroy/Gilroy-Light.woff2'

import GilroyMediumWOFF from './fonts/Gilroy/Gilroy-Medium.woff'
import GilroyMediumWOFF2 from './fonts/Gilroy/Gilroy-Medium.woff2'

import GilroyHeavyWOFF from './fonts/Gilroy/Gilroy-Heavy.woff'
import GilroyHeavyWOFF2 from './fonts/Gilroy/Gilroy-Heavy.woff2'

export default {
    GilroyRegularWOFF,
    GilroyRegularWOFF2,
    GilroyExtraboldWOFF,
    GilroyExtraboldWOFF2,
    GilroyThinWOFF,
    GilroyThinWOFF2,
    GilroyBoldWOFF,
    GilroyBoldWOFF2,
    GilroyBlackWOFF,
    GilroyBlackWOFF2,
    GilroyLightWOFF,
    GilroyLightWOFF2,
    GilroyMediumWOFF,
    GilroyMediumWOFF2,
    GilroyHeavyWOFF,
    GilroyHeavyWOFF2
}